<template>
    <el-row class="footer">
        <el-row>
            <img style="width: 40%;height: auto; margin-top: 80px;" src="../assets/imgs/footer/qrcode.jpg" />
        </el-row>
        <el-row class="second">长春市三合通科技有限责任公司</el-row>
        <el-row class="second">地址：长春市净月开发区净月影视文化创意产业园5号楼A区6层</el-row>
        <el-row class="second">电话：19944841741</el-row>
        <el-row class="second">邮箱：wuy@ccsht.cn</el-row>
        <el-row class="second" @click.native="recordClick">备案号：吉ICP备2020004345号-1</el-row>
    </el-row>
</template>

<script>
    export default {
        name: "MobileFooter",
        methods: {
            toPage (path) {
                this.$router.push({
                    path: path
                });
            },
            recordClick () {
                window.open('https://beian.miit.gov.cn', 'target');
            }
        }
    }
</script>

<style scoped>
.footer {
    height: 400px;
    width: 100%;
    color: #777777;
    text-align: center;
    background: #262626;
    font-size: 13px;
}

.first {
    width: 100%;
    height: 60px;
    color: #a8a8a8;
    background: #1b1b1b;
    padding: 0 8%;
}

.item {
    height: 60px;
    line-height: 60px;
}

.text-right {
    text-align: right;
}

.text-center {
    text-align: center;
}

.footer-row {
    margin-bottom: 10px;
}

.second {
    padding: 1% 5%;
}

.pointer {
    cursor: pointer;
}

.pointer:hover {
    color: #ffffff;
}
</style>
